module.exports = __webpack_public_path__ + "static/media/transfers.00a462f1.svg";